module.exports = __webpack_public_path__ + "logback.2a4b27.svg";